import { CommonQuestionKeys } from '@bybeam/platform-types';
import STANDARD_COMPONENTS from '../standards/index.js';
import { makeEduConfig } from './baseConfig.js';

const CONFIG = makeEduConfig();

const personalInfoSection = CONFIG.sections.find(({ key }) => key === 'personalInfo');
personalInfoSection.questionGroups[1].questions.push(
  STANDARD_COMPONENTS.definitions.questions[CommonQuestionKeys.MAILING_ADDRESS],
);
export default CONFIG;
